import { z } from 'zod';
import * as v from './common';

export const DomainSchema = z.object({
  domain: v.domainPopup,
});
